import { Heading, HeadingProps } from "@chakra-ui/react";

export function FormLabel({ children, ...rest }: HeadingProps) {
  return (
    <Heading
      as="h2"
      fontSize="16px"
      color="#316489"
      fontWeight="bold"
      textTransform="uppercase"
      margin="8px 0 8px 0"
      {...rest}
    >
      {children}
    </Heading>
  );
}
